import { useState } from 'react';
import { hasCookieConsent, setCookieConsent } from '../lib/storage';

export const useCookieConsent = () => {
  const [visible, setVisible] = useState(() => !hasCookieConsent());

  const handleVisible = () => {
    setCookieConsent();
    setVisible(false);
  }

  return { visible, handleVisible };
};
